import { render } from "./assessApproval.vue?vue&type=template&id=d2fbca02&scoped=true"
import script from "./assessApproval.vue?vue&type=script&lang=js"
export * from "./assessApproval.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2fbca02"]])

export default __exports__